import { usePostTimesheetSubmitSettled } from '@sit/openapi';
import { track } from '@web/analytics/analyticsClient';
import trackEvents from '@web/analytics/trackEvents';
import { setSyncStatus } from '@web/services/timesheet-sync-status';
import { useCallback } from 'react';

export const useTimesheetSubmitSettled = () => {
  const onSettle = usePostTimesheetSubmitSettled();
  return useCallback(
    async (timesheetId: string, isSuccess: boolean) => {
      await onSettle(timesheetId);
      if (isSuccess) {
        setSyncStatus({ timesheetId, synced: true });
        track(trackEvents.TIMESHEET_SUBMIT);
      }
    },
    [onSettle],
  );
};
